import { CATEGORY_ROUTES } from 'src/types/news'
import { Categories } from 'src/store/ducks/categories/types'

export default function getCategoryRouteByCategoryId(
  newsCategoriesId: number | null,
  categories: Categories[]
): string | null {
  if (!categories || categories.length === 0 || newsCategoriesId === null) {
    return ''
  }
  const cat = categories.find((e: any) => e.id === newsCategoriesId)
  return cat ? CATEGORY_ROUTES[cat.title] || null : null
}
